export default __webpack_public_path__ + "static/media/content-deco-4.d1f56381.webp";